export interface TopoOverlayView extends google.maps.OverlayView {}

function extend(type1: any, type2: any): void {
  for (let property in type2.prototype) {
    type1.prototype[property] = type2.prototype[property];
  }
}

export class TopoOverlayView {
  constructor() {
    // We use the extend function for google.maps.OverlayView
    // because it might not always be available when the code is defined.
    extend(TopoOverlayView, google.maps.OverlayView);
  }
}